var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"value":_vm.value,"max-width":"800px"},on:{"input":function($event){return _vm.$emit('input')}}},[_c('v-card',[_vm._v(" Map coming soon ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }